// Company size tiers (affects opportunity cost calculation, CMS options, AOR pricing, and project pricing)
// Each tier has appropriate AOR pricing, project multiplier, and in-house comparison
export const COMPANY_SIZES = {
  startup: {
    name: 'Startup / SMB',
    weeklyOpportunityCost: 25000,
    description: 'Under $10M revenue',
    typicalCMS: ['squarespace', 'wix', 'wordpress', 'strapi'],
    projectMultiplier: 1.0,
    benefitsMultiplier: 1.2,
    aorMonthly: 7500,
    aorName: 'Starter',
    defaultInHouseRoleIds: ['marketing_manager', 'freelance_dev_support'],
    inHouseComparison: {
      description: 'Hiring 1 full-time person',
      roles: [
        { role: 'Marketing Manager or Designer', salary: 95000 },
        { role: '+ Freelance Dev Support', salary: 36000 },
      ],
      totalBase: 131000,
      withBenefits: 158000,
    },
  },
  midmarket: {
    name: 'Mid-Market',
    weeklyOpportunityCost: 50000,
    description: '$10M - $100M revenue',
    typicalCMS: ['contentful', 'drupal', 'wordpress', 'strapi'],
    projectMultiplier: 1.25,
    benefitsMultiplier: 1.3,
    aorMonthly: 20000,
    aorName: 'Growth',
    defaultInHouseRoleIds: ['marketing_manager', 'designer', 'developer'],
    inHouseComparison: {
      description: 'Hiring a small in-house team',
      roles: [
        { role: 'Marketing Manager', salary: 120000 },
        { role: 'Designer', salary: 110000 },
        { role: 'Developer', salary: 130000 },
      ],
      totalBase: 360000,
      withBenefits: 468000,
    },
  },
  enterprise: {
    name: 'Enterprise',
    weeklyOpportunityCost: 150000,
    description: '$100M - $500M revenue',
    typicalCMS: ['contentful', 'sitecore', 'drupal', 'aem'],
    projectMultiplier: 1.5,
    benefitsMultiplier: 1.3,
    aorMonthly: 35000,
    aorName: 'Scale',
    defaultInHouseRoleIds: [
      'creative_director',
      'brand_strategist',
      'uiux_designer',
      'senior_graphic_designer',
      'developer',
      'project_manager',
    ],
    inHouseComparison: {
      description: 'Building a full creative team',
      roles: [
        { role: 'Creative Director', salary: 189000 },
        { role: 'Brand Strategist', salary: 132000 },
        { role: 'UI/UX Designer', salary: 132000 },
        { role: 'Sr. Graphic Designer', salary: 107000 },
        { role: 'Developer', salary: 130000 },
        { role: 'Project Manager', salary: 106000 },
      ],
      totalBase: 796000,
      withBenefits: 1035000,
    },
  },
  largeEnterprise: {
    name: 'Large Enterprise',
    weeklyOpportunityCost: 300000,
    description: '$500M+ revenue',
    typicalCMS: ['sitecore', 'aem', 'contentful'],
    projectMultiplier: 1.75,
    benefitsMultiplier: 1.3,
    aorMonthly: 75000,
    aorName: 'Enterprise',
    defaultInHouseRoleIds: [
      'creative_director',
      'brand_strategist',
      'uiux_designer',
      'senior_graphic_designer',
      'webflow_developer',
      'project_manager',
      'paid_media_planner',
    ],
    inHouseComparison: {
      description: 'Building a full creative department',
      roles: [
        { role: 'Creative Director', salary: 189000 },
        { role: 'Brand Strategist', salary: 132000 },
        { role: 'UI/UX Designer', salary: 132000 },
        { role: 'Sr. Graphic Designer', salary: 107000 },
        { role: 'Webflow Developer', salary: 90000 },
        { role: 'Project Manager', salary: 106000 },
        { role: 'Paid Media Planner', salary: 80000 },
      ],
      totalBase: 836000,
      withBenefits: 1087000,
    },
  },
};
